import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onConsentChange } from "@/lib/tracking";

const STORAGE_KEY = "ep-cookies-consent";

export default function CookieBanner() {
  const [choice, setChoice] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    setChoice(stored);
    setReady(true);
  }, []);

  const set = (v) => {
    localStorage.setItem(STORAGE_KEY, v);
    setChoice(v);
    // Let tracking module know so pixels can fire immediately after Accept.
    if (v === "accepted") onConsentChange();
  };

  if (!ready || choice) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:bottom-6 md:right-6 md:max-w-md z-[60] rounded-xl border border-[color:var(--gold)]/40 shadow-2xl"
      style={{ background: "rgba(10, 17, 40, 0.96)", backdropFilter: "blur(12px)" }}
    >
      <div className="p-5 md:p-6">
        <div className="label-overline text-[color:var(--gold)]">A gentle nudge</div>
        <p className="mt-2 text-[color:var(--parchment-soft)] font-sans-body text-sm leading-relaxed">
          We only use essential cookies to make the site work. If we ever add analytics (e.g. to measure a TikTok/IG campaign), we&apos;ll ask first. See our <Link to="/cookies" className="text-[color:var(--gold)] underline">Cookie Policy</Link> and <Link to="/privacy" className="text-[color:var(--gold)] underline">Privacy Policy</Link>.
        </p>
        <div className="mt-4 flex gap-2">
          <button
            onClick={() => set("accepted")}
            data-testid="cookie-accept"
            className="flex-1 h-10 rounded-full bg-[color:var(--gold)] hover:bg-[color:var(--gold-soft)] text-[color:var(--bg-base)] font-sans-body text-sm"
            style={{ transition: "background-color 200ms ease" }}
          >
            Accept
          </button>
          <button
            onClick={() => set("declined")}
            data-testid="cookie-decline"
            className="flex-1 h-10 rounded-full border border-[color:var(--gold)]/40 hover:border-[color:var(--gold)] text-[color:var(--parchment)] font-sans-body text-sm"
            style={{ transition: "border-color 200ms ease" }}
          >
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
}
